import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import Tab from '../../../../../../components/Tabs/Tab';
import OverChargeDetails from '../Components/OverChargeDetails/OverChargeDetails';
import OverChargeItems from '../Components/OverChargeItems/OverChargeItems';
import OverChargeNotes from '../Components/OverChargeNotes/OverChargeNotes';
import OverChargeSettlements from '../Components/OverChargeSettlements/OverChargeSettlements';

const OverChargeEditTabs = ({ activeKey, handleTabChange }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const tabs = useMemo(
    () => [
      {
        title: t('translation:claims.Details'),
        content: <OverChargeDetails />,
        contentKey: '1',
      },
      {
        title: t('translation:claims.overchargeClaimItems'),
        content: <OverChargeItems />,
        contentKey: '2',
      },
      {
        title: t('translation:claims.overchargeClaimNotes'),
        content: <OverChargeNotes />,
        contentKey: '3',
      },
      {
        title: t('translation:claims.overchargeClaimSettlements'),
        content: <OverChargeSettlements />,
        contentKey: '4',
      },
    ],
    [],
  );

  return <Tab onChange={handleTabChange} contents={tabs} defaultActiveKey="1" activeKey={activeKey} />;
};

export default OverChargeEditTabs;
